/* eslint-disable no-useless-escape */
/* eslint-disable import/prefer-default-export */
import { all } from './codeOperators';

export const VINRegexp = '^[0-9ABCDEFGHJKLMNPRSTUVWXYZabcdefghjklmnprstuvwxyz]{0,17}$';

export const numberWithSpacesRegexp = '^[0-9 ]{0,15}$';

export default {
  phoneOperators: new RegExp(
    `^(\\+[0-9]{2}\\((${all})\\)[0-9]{3}-[0-9]{2}-[0-9]{2}|(\\+38|38|8)?(${all})[0-9]{7})$`,
  ),
  password: /.{0,}/,
  number: /^[0-9]{0,50}$/,
  phone: new RegExp(
    `^(\\+[0-9]{2}\\(([0-9]{3})\\)[0-9]{3}-[0-9]{2}-[0-9]{2}|(\\+38|38|8)?([0-9]{3})[0-9]{7})$`,
  ),
  phoneNormalize: /^(\+38|38|8)?[0-9]{10}$/,
  name: /^[0-9a-zабвгґдеєжзиіїйклмнопрстуфхцчшщьюяёъыэя\ʼ\'\`\-\s]{1,100}$/i,
};



// WEBPACK FOOTER //
// ./src/shared/constants/regexp.js